import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { endRubberline, stepBackRubberLine } from "../../../store/interaction";
import { /*hitStrokeCorrection,*/ strokeCorrection } from "../util/strokeCorrection";
import { insertShape } from "../../../store/model";
import BaseImage from "../shapes/symbol/SymbolBase";
import { useSnapMousePosition } from "./useSnapMousePosition";
import { RootState } from "../../../store/store";
import { useCallback, useEffect, useMemo } from "react";
import { recalculateShape } from "../util/shapeEdit";

const SymbolRubber = () => {
  const dispatch = useAppDispatch();
  const interaction = useAppSelector((state: RootState) => state.interaction)
  const scale = useAppSelector((state: RootState) => state.interface.viewport.scale)
  const defaultSetting = useAppSelector((state: RootState) => state.tool.toolSettings.symbol.current);
  const mousePositionSnap = useSnapMousePosition();

  const rubberlineLength = interaction.rubberlineData.snapPoints.length;
  //const rubberline = interaction.rubberlineData.snapPoints;
  //const rubberlinePointer = interaction.rubberlineData.pointerPoints;
  const editState = interaction.editorState;
  //const SAMEPOINT_DISTANCE = 10;

  const internalProperties = useMemo(() => {
    return {
      ...defaultSetting,
      id: 0,
      strokeWidth: strokeCorrection(defaultSetting.strokeWidth, scale),
      points: interaction.rubberlineData.snapPoints.concat(mousePositionSnap),
      closed: false,
    }
  }, [defaultSetting, interaction.rubberlineData.snapPoints, mousePositionSnap, scale])

  // const clickedSamePoint = useCallback(() => {
  //   return rubberlineLength >= 2 ? (
  //     (Math.abs(rubberlinePointer[rubberlineLength - 1].x - rubberline[rubberlineLength - 2].x) < (SAMEPOINT_DISTANCE / scale)) &&
  //     (Math.abs(rubberlinePointer[rubberlineLength - 1].y - rubberline[rubberlineLength - 2].y) < (SAMEPOINT_DISTANCE / scale))
  //   ) : false
  // }, [rubberlineLength, rubberlinePointer, rubberline, scale])

  const finishRubberimage = useCallback(function () {
    // let validPointOfLine = clickedSamePoint()
    //   ? interaction.rubberlineData.snapPoints.filter((_x, i) => i < (rubberlineLength - 1))
    //   : interaction.rubberlineData.snapPoints;

    dispatch(insertShape(
      recalculateShape(assembleShapeToInsert<SymbolShape>({ ...internalProperties,  }),
      )))
    dispatch(endRubberline());
  }, [/*clickedSamePoint,*//* rubberline,*/ dispatch, /*interaction.rubberlineData.snapPoints,*/ internalProperties, /*rubberlineLength*/])

  useEffect(() => {
    const handleRubberLine = (e: KeyboardEvent) => {
      switch (e.key) {
        case "Backspace":
          if (editState === 'normal') {
            dispatch(stepBackRubberLine(1));
          }
          break;
        default:
          break;
      }
    }
    window.addEventListener("keydown", handleRubberLine);
    return () => window.removeEventListener("keydown", handleRubberLine);
  }, [dispatch, editState])

  if (rubberlineLength === 0) {
    //dispatch(setToolMessage("define start point"))
    return (
      <></>
    )
  }
  if (rubberlineLength === 1) {
    finishRubberimage();
  } else {

    //dispatch(setToolMessage("define endpoint"))
    return (
      <BaseImage shapeProps={internalProperties} />
    )
  }

  return <></>
}

function assembleShapeToInsert<L>(shape: L): L {
  return shape;
}
export const createImageRubber = () => {
  return <SymbolRubber />
};

export default SymbolRubber;